import React, { RefObject } from 'react';
import {
  Location,
  LocationLevel,
} from '../../graphQL/types/shared';
import { gql, useQuery } from '../../graphQL/useQuery';
import { SlideElementProps } from '../../presentationManager/PresentationManager';
import SectionNav, {
  IProps as ISectionNavProps,
} from './SectionNav';

const query = gql`
  query SectionNav($level: LocationLevel) {
    sectionNav: allLocations(level: $level) {
      id
      shortName
    }
  }
`;

interface FetchedDatum {
  id: Location['id'];
  shortName: Location['shortName'];
}

interface ISuccessResponse {
  sectionNav: FetchedDatum[];
}

type Props = Omit<ISectionNavProps, 'countryName' | 'rootElRef'> & SlideElementProps & {
  countryId: string,
};

const SectionNavQueryWrapper = React.forwardRef((props: Props, rootElRef: RefObject<HTMLDivElement>) => {
  const {loading, error, data} = useQuery<ISuccessResponse, {level: LocationLevel}>(query, {
    variables: {level: LocationLevel.country},
  });
  const {
    startingIndexOfFirstSection, slideIndex, setSlideIndex,
    year, getFluentString, countryId, helpTooltipIndex, isHelpActive,
  } = props;
  const fallbackCountryName = getFluentString(
    'section-nav-slide-diversification-strategic-approach-backup-country-name',
  );
  let countryName: string;
  if (loading === true) {
    countryName = fallbackCountryName;
  } else if (error !== undefined) {
    countryName = fallbackCountryName;
    console.error(error);
  } else if (data !== undefined) {
    const foundCountryName = data.sectionNav.find(elem => elem.id === countryId);
    countryName = (foundCountryName === undefined) ? fallbackCountryName : foundCountryName.shortName;
  } else {
    countryName = fallbackCountryName;
  }
  return (
    <SectionNav
      startingIndexOfFirstSection={startingIndexOfFirstSection}
      slideIndex={slideIndex}
      setSlideIndex={setSlideIndex}
      year={year}
      getFluentString={getFluentString}
      countryName={countryName}
      zIndex={props.zIndex}
      rootElRef={rootElRef}
      helpTooltipIndex={helpTooltipIndex}
      isHelpActive={isHelpActive}
    />
  );
});

export default SectionNavQueryWrapper;
